<template>
  <v-content>
    <v-container>
      <v-card max-width="1000" class="mx-auto mt-10" :loading="loading">
        <v-card-actions v-if="canUserCreateNewArticle">
          <v-spacer></v-spacer>
          <v-btn color="primary" class="mr-4 mt-4 mb-2" @click="newArticle">{{
            $t("newsfeed.newsFeedList.createNewArticle")
          }}</v-btn>
        </v-card-actions>
        <div v-if="loading">
          <v-skeleton-loader
            v-for="(i, index) in 10"
            :key="index"
            class="mx-auto"
            type="divider, list-item-avatar, list-item-two-line, divider"
          ></v-skeleton-loader>
        </div>
        <div v-else>
          <news-feed-item
            v-if="drafts.lenght !== 0"
            :news-feed-items="drafts"
            @load-new-data="handleLoadNewData"
            @check-for-new-group-load="checkForNextLoad"
            @edit="edit"
            @details="details"
          ></news-feed-item>
          <news-feed-item
            v-if="scheduled.lenght !== 0"
            :news-feed-items="scheduled"
            @load-new-data="handleLoadNewData"
            @check-for-new-group-load="checkForNextLoad"
            @edit="edit"
            @details="details"
          ></news-feed-item>
          <news-feed-item
            v-if="published.lenght !== 0"
            :news-feed-items="published"
            @load-new-data="handleLoadNewData"
            @check-for-new-group-load="checkForNextLoad"
            @edit="edit"
            @details="details"
          ></news-feed-item>
        </div>

        <div
          v-if="
            drafts.lenght === 0 &&
            scheduled.lenght === 0 &&
            published.lenght === 0
          "
        >
          <v-list two-line>
            <v-divider></v-divider>
            <v-subheader class="text-capitalize"></v-subheader>
            <v-list-item class="pb-4">
              <v-list-item-avatar>
                <v-avatar color="primary">
                  <v-icon dark> mdi-newspaper-minus </v-icon>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-content class="pr-8">
                <v-list-item-title>
                  {{ $t("newsfeed.newsFeedList.thereAreNoArticlesAvailable") }}
                </v-list-item-title>

                <v-list-item-subtitle class="mb-2"></v-list-item-subtitle>
              </v-list-item-content> </v-list-item
          ></v-list>
        </div>
        <!-- </template> -->
      </v-card>
      <delete-dialog
        :dialog="deleteDialog.active"
        :item="deleteDialog.title"
        @agree="handleRemove"
        v-show="false"
      />
    </v-container>
  </v-content>
</template>

<script>
import api from "@/utils/api";
import snackbar from "@/utils/snackbar";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import restrictions from "@/utils/restrictions";
import NewsFeedItem from "@/components/newsfeed/NewsFeedItem";
export default {
  components: {
    DeleteDialog,
    NewsFeedItem,
  },
  data: () => ({
    loading: true,
    getUuid: null,
    nextUrl: null,
    deleteDialog: { active: false, title: "" },
    loadingNextPage: false,
    loadingNextGroup: false,
    selected: [],
    canUserCreateNewArticle: false,
    drafts: {
      results: [],
      uuid: null,
      group: "drafts",
      loaded: false,
      initalLoad: false,
    },
    published: {
      results: [],
      uuid: null,
      group: "published",
      loaded: false,
      initalLoad: false,
    },
    scheduled: {
      results: [],
      uuid: null,
      group: "scheduled",
      loaded: false,
      initalLoad: false,
    },
  }),
  created() {
    let promises = [
      restrictions.canUserCreateNewArticle(),
      api.getNewsFeedList({ draft: "True", ordering: "-pined,-created" }),
      api.getNewsFeedList({
        scheduled: "True",
        ordering: "-pinned,-date_published",
      }),
      api.getNewsFeedList({
        published: "True",
        ordering: "-pinned,-date_published",
      }),
    ];
    Promise.all(promises).then((values) => {
      this.mapNewsFeedData(values[1], "drafts", "Drafts");
      this.mapNewsFeedData(values[2], "scheduled", "Scheduled");
      this.mapNewsFeedData(values[3], "published", "Published");
      this.canUserCreateNewArticle = values[0];
      this.loading = false;
    });
  },
  mounted() {},

  // watch: {
  //   "drafts.loaded": function (newVal, oldVal) {
  //     this.checkForNextLoad();
  //   },
  //   "published.loaded": function (newVal, oldVal) {
  //     this.checkForNextLoad();
  //   },
  //   "scheduled.loaded": function (newVal, oldVal) {
  //     this.checkForNextLoad();
  //   },
  // },

  methods: {
    mapNewsFeedData(resp, action, group) {
      let data = resp.data;
      data.group = action;
      data.loaded = false;
      data.initalLoad = true;

      if (resp.data.results.length !== 0) {
        data.uuid = this.getNextPageUuid(resp);
        data.results = resp.data.results.map((item, index, array) => {
          return {
            ...item,
            type: action,
            date_published_prettified:
              item.date_published !== null
                ? this.$moment(item.date_published).fromNow()
                : "",
          };
        });
      } else {
        data.loaded = true;
      }

      switch (action) {
        case "drafts":
          this.drafts = data;
          break;
        case "published":
          this.published = data;
          break;
        case "scheduled":
          this.scheduled = data;
          break;
      }
    },

    handleLoadNewData(path, action, callback) {
      if (this.loadingNextPage || path === null) {
        return;
      }
      this.loadingNextPage = true;
      api.getNewsFeedNextPage(path).then((resp) => {
        // this.getNextPage(resp, data);
        let results = resp.data.results.map((element) => {
          return {
            ...element,
            date_published_prettified: this.$moment(
              element.date_published
            ).fromNow(),
          };
        });

        switch (action) {
          case "drafts":
            this.drafts.results = [...this.drafts.results, ...results];
            this.drafts.next = resp.data.next;
            this.drafts.uuid = this.getNextPageUuid(resp);
            this.drafts.loaded = resp.data.next === null ? true : false;
            break;
          case "published":
            this.published.results = [...this.published.results, ...results];
            this.published.next = resp.data.next;
            this.published.uuid = this.getNextPageUuid(resp);
            this.published.loaded = resp.data.next === null ? true : false;
            break;
          case "scheduled":
            this.scheduled.results = [...this.scheduled.results, ...results];
            this.scheduled.next = resp.data.next;
            this.scheduled.uuid = this.getNextPageUuid(resp);
            this.scheduled.loaded = resp.data.next === null ? true : false;
            break;
        }
        callback(false);
        this.loadingNextPage = false;
      });
    },

    checkForNextLoad() {
      if (!this.drafts.loaded) {
        return;
      }

      if (
        this.drafts.loaded &&
        !this.scheduled.initalLoad &&
        !this.loadingNextGroup
      ) {
        this.loadingNextGroup = true;
        api.getNewsFeedList({ scheduled: "True" }).then((resp) => {
          this.mapNewsFeedData(resp, "scheduled", "Scheduled");
          this.loadingNextGroup = false;
        });
      }

      if (
        this.drafts.loaded &&
        this.scheduled.loaded &&
        !this.published.initalLoad &&
        !this.loadingNextGroup
      ) {
        this.loadingNextGroup = true;
        api.getNewsFeedList({ published: "True" }).then((resp) => {
          this.mapNewsFeedData(resp, "published", "published");
          this.loadingNextGroup = false;
        });
      }
    },

    getNextPageUuid(resp) {
      let index = Math.abs(
        Math.ceil(
          (resp.data.results.length * 30) / 100 - resp.data.results.length
        )
      );
      return resp.data.results[index].uuid;
    },

    handleRemove(agreed) {
      if (agreed) {
        api.deleteNewsFeed(this.deleteDialog.item.uuid).then((resp) => {
          snackbar.success(
            this.$t("utils.snackbar.success.successfullyDeleted")
          );
          this.fetchNewsFeed(this.$route.query);
        });
      }
      this.deleteDialog = { active: false, title: "", item: null };
    },

    remove(item) {
      this.deleteDialog = { active: true, title: item.title, item: item };
    },
    handleGroupSelect(item) {
      item.is_editable ? this.edit(item) : this.details(item);
    },
    edit(item) {
      this.$router.push({
        name: "newsFeedEdit",
        params: { id: item.uuid },
      });
    },
    details(item) {
      this.$router.push({
        name: "newsFeedDetails",
        params: { id: item.uuid },
      });
    },
    newArticle() {
      this.$router.push({
        name: "newsFeedNew",
      });
    },
  },
};
</script>
<style scoped>
.list-item--background-color {
  background-color: rgba(50, 165, 196, 0.2);
}
</style>
